<template>
	<div>
		
	</div>
</template>
<script>
	export default {
		name: 'logout',
		created() {
			this.$store.dispatch('logout')
				.then(response => {
					this.$router.push('/')
				.catch(err => {
					if (err.name !== 'NavigationDuplicated' && !err.message.includes('Avoided redundant navigation to current location')) 
						console.log(err);
				});
			});
		}
	}
</script>